(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-favorites"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('editorial-best-sellers')) {
    customElements.define('editorial-best-sellers', class extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.source || this.loaded) return;
        this.loaded = true;
        this.controller = new AbortController();
        fetch(this.dataset.source, { signal: this.controller.signal })
          .then(response => {
            if (!response.ok) throw new Error('Best sellers unavailable');
            return response.text();
          })
          .then(html => {
            const incoming = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sales-ranked]');
            const current = this.querySelector('.editorial-favorites__grid');
            if (!incoming?.children.length || !current || !this.isConnected || this.contains(document.activeElement)) return;
            current.replaceChildren(...incoming.children);
            this.dataset.ranking = 'retail-90-day';
          })
          .catch(() => {});
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.loaded = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fomo-holdingpage"] && !Shopify.designMode) return;
  try {
    
function redirect(event){
  event.preventDefault();
  location.href= document.getElementById('redirect_button').dataset.url;
}
function isnull(id){
  const input = document.getElementById(id);
  return input.value == null || input.value.trim() == '';
}
function validateEmailString(email) {
  var re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
  return re.test(email);
}
function validateFirstname(event){
  const nameField = document.getElementById('ContactForm-firstname-field');
  const errorField = document.getElementById('ContactForm-firstname-error');
  if(isnull('ContactForm-firstname')){
    nameField.classList.add('error');
    errorField.style.display = 'block';
    event.preventDefault();
  }else{
    errorField.style.display = 'none';
    nameField.classList.remove('error');
  }
}
function validateLastname(event){
  const nameField = document.getElementById('ContactForm-lastname-field');
  const errorField = document.getElementById('ContactForm-lastname-error');
  if(isnull('ContactForm-lastname')){
    nameField.classList.add('error');
    errorField.style.display = 'block';
    event.preventDefault();
  }else{
    errorField.style.display = 'none';
    nameField.classList.remove('error');
  }
}
function validateEmail(event){
  const emailField = document.getElementById('ContactForm-email-field');
  const errorField = document.getElementById('ContactForm-email-error')
  const errorFormatField = document.getElementById('ContactForm-emailformat-error')
  if(isnull('ContactForm-email')){
    emailField.classList.add('error');
    errorField.style.display = 'block';
    event.preventDefault();
  }else{
    errorField.style.display = 'none';
    emailField.classList.remove('error');
    if(!validateEmailString(document.getElementById('ContactForm-email').value)){
      emailField.classList.add('error');
      errorFormatField.style.display = 'block';
      event.preventDefault();
    }else{
      emailField.classList.remove('error');
      errorFormatField.style.display = 'none';
    }
  }
}
  
function validateForm(event){
  validateFirstname(event);
  //validateLastname(event);
  validateEmail(event);
}
  
document.addEventListener('DOMContentLoaded', function() {
  if(document.getElementById('btnSubmit')) document.getElementById('btnSubmit').addEventListener('mousedown',validateForm);
  if(document.getElementById('ContactForm-email')) document.getElementById('ContactForm-email').addEventListener('blur',validateEmail);
  if(document.getElementById('ContactForm-name')) document.getElementById('ContactForm-name').addEventListener('blur',validateName);
  if(document.getElementById('redirect_button')) document.getElementById('redirect_button').addEventListener('click',redirect);

  const fomoCarouselImages = document.getElementsByClassName("signup-carousel-image");
  const fomoCarouselCount = fomoCarouselImages.length;

  const unmute = document.getElementById('holding-video-unmute');
  if(unmute){
    unmute.addEventListener('click',function(){
      const v = document.getElementById('video');
      v.muted = !v.muted;
      const vt = document.getElementById('video-text');
      if(v.muted){ vt.innerText = vt.dataset.unmute; }
      else{ vt.innerText = vt.dataset.mute; }
    })
  }

  const unmutemobile = document.getElementById('holding-video-unmute-mobile');
  if(unmutemobile){
    unmutemobile.addEventListener('click',function(){
      const v = document.getElementById('video');
      v.muted = !v.muted;
      const vt = document.getElementById('video-text-mobile');
      if(v.muted){ vt.innerText = vt.dataset.unmute; }
      else{ vt.innerText = vt.dataset.mute; }
    })
  }

  if(fomoCarouselImages.length > 1){
    let index = 0;
    
    const speedSettings = document.getElementsByClassName("fomo-holding-page")[0];
    const speed = speedSettings.dataset && speedSettings.dataset.speed ? speedSettings.dataset.speed * 1000 : 4000;
    const swap = setInterval(async function() {
      const useMobile = window.innerWidth <= 900;
      const target = document.getElementsByClassName('fomo-signup-bg')[0];
      let targetUpdateDesktop = document.getElementsByClassName(`signup-carousel-image-${ index }`)[0];
      let targetElement = targetUpdateDesktop;
      if(useMobile){
        let targetUpdateMobile = document.getElementsByClassName(`signup-carousel-mobile-image-${ index }`);
        if(targetUpdateMobile.length > 0){
          targetElement = targetUpdateMobile[0];
        }
      }
      
      let textElement = document.getElementsByClassName('title-text');
      if(textElement.length > 0){
        let targetText = document.getElementsByClassName(`signup-carousel-image-text-${ index }`)[0];  
        textElement[0].innerText = targetText.innerText;
      }
      
      target.style['background-image'] = `url('${targetElement.src}')`;
      const images = document.getElementsByClassName('signup-carousel-target-image');
      for(let i = 0, c = images.length;i<c;i++){
        if(images[i].tagName == "IMG") images[i].src = targetElement.src;
      }
      index += 1;
      if(index == fomoCarouselCount) index = 0;
    },speed);
  };

  const signupTextPre = document.getElementById('fomo-signup-signedup-text-pre');
  const signupTextPost = document.getElementById('fomo-signup-signedup-text-post');
  const queryString = window.location.search;
  if((signupTextPre || signupTextPost) && queryString.indexOf('form_type=customer') > -1){
    const btnSubmit = document.getElementById('btnSubmit');
    const descriptionTextPre = document.getElementById('fomo-signup-description-text-pre');
    const descriptionTextPost = document.getElementById('fomo-signup-description-text-post');
    if(descriptionTextPost) descriptionTextPost.style.display = 'none';
    if(descriptionTextPre) descriptionTextPre.style.display = 'none';
    if(signupTextPre) signupTextPre.style.display = 'block';
    if(signupTextPost) signupTextPost.style.display = 'block';
    btnSubmit.disabled = true;
  }

  // UTM fields management
  const urlParams = new URLSearchParams(queryString);
  if(document.getElementById('utm_id')) { document.getElementById("utm_id").value = urlParams.get("utm_id"); }
  if(document.getElementById('utm_source')) { document.getElementById("utm_source").value = urlParams.get("utm_source"); }
  if(document.getElementById('utm_medium')) { document.getElementById("utm_medium").value = urlParams.get("utm_medium"); }
  if(document.getElementById('utm_campaign')) { document.getElementById("utm_campaign").value = urlParams.get("utm_campaign"); }				  
  if(document.getElementById('final_tags')) {
    const elements = Array.from(document.querySelectorAll('[name="contact[tags]"]'));
    const tags = elements.map(o => o.value).filter(val => val != null && val !== '').join(",");
    document.getElementById('final_tags').value = tags;    
  }
  // ~UTM fields management  
});

const fct = document.getElementById('fomo-holding-countdown-timer');
const maxWeek = 1000 * 60 * 24 * 7;
const maxDay = 1000 * 60 * 60 * 24;

const calendarButton = document.getElementById('add-to-calendar');
if(fct){
  function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }
  
  const startDate = new Date(fct.dataset.startdate);
  const endDate = new Date(fct.dataset.enddate);
  const calendarEndDate = addDays(startDate,1);
  const nowTime = new Date().getTime();
  const startDiff = startDate.getTime() - nowTime;
  
  if(calendarButton && startDiff > 0){
    function ToRFCString(date){
      const y = date.getFullYear();
      const m = String(date.getMonth()+1).padStart(2,'0');
      const d = String(date.getDate()).padStart(2,'0'); 
      const h = String(date.getHours()).padStart(2,'0'); 
      const mi = String(date.getMinutes()).padStart(2,'0'); 
      const s = String(date.getSeconds()).padStart(2,'0'); 
      return `${y}${m}${d}T${h}${mi}${s}`;
    }
    
    const start = ToRFCString(startDate);
    const end = ToRFCString(calendarEndDate);
    const cDates = `${start}/${end}`;
    calendarButton.href=`https://calendar.google.com/calendar/render?action=TEMPLATE&dates=${cDates}&details=${calendarButton.dataset.description}&text=${calendarButton.dataset.title}`;
    calendarButton.style.display = 'block';
  }
  
  const section = document.getElementById('fomo-holding-page');
  const designMode = section.classList.contains("designmode")
  if(!designMode){
    const endDiff = endDate.getTime() - nowTime;

    const observer = new MutationObserver(function(mutations){
      mutations.forEach(function(mutationRecord){
        if(mutationRecord.target.style.overflow == 'scroll'){
          mutationRecord.target.style.removeProperty('overflow');
        }
      })
    });

    observer.observe(document.body, { attributes : true, attributeFilter : ['style'] });

    const showPost = function(){
      const container = document.getElementById('fomo-holding-page-inner');
      const style = document.getElementById('holdingpage-stylesheet');
      const section = document.getElementById('fomo-holding-page');
      container.style.display = 'block';
      section.classList.add('post');
      style.sheet.cssRules[0].selectorText = 'body';
      section.classList.remove('pre');
      section.classList.remove('hidden');
    }

    const postTimer = function(){
      const nt = new Date().getTime();
      const ed = endDate.getTime() - nt;
      const timer = ed > maxDay ? maxDay : ed;
      const timeout = setInterval(function(){
        if(ed > 0){
          postTimer();
        }else{
          showPost();
        }
        clearInterval(timeout);
      },timer);
    }
    
    const sale = function(){
      const nt = new Date().getTime();
      const ed = endDate.getTime() - nt;
      const style = document.getElementById('holdingpage-stylesheet');
      style.sheet.cssRules[0].selectorText = 'body_ignore'
      const section = document.getElementById('fomo-holding-page');
      section.classList.add('hidden');
      postTimer();
    }
    if(startDiff <= 0 && endDiff > 0) sale();
    else {
      const section = document.getElementById('fomo-holding-page');
      const container = document.getElementById('fomo-holding-page-inner');
      container.style.display = 'block';
      if(startDiff > 0){
        section.classList.add('pre');
        if(maxWeek > startDiff){
          const timeout = setInterval(function(){ 
            sale();
            clearInterval(timeout);
          },startDiff);
        }
      } else {
        section.classList.add('post');
      }
    }
    const hbtn = document.getElementById('hidden-button');
    hbtn.addEventListener('click',function(){
      var password = prompt("Enter in the password");
      if(password.trim() == hbtn.dataset.p){
        sale();
      }
    })
  }
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fomo-signup"] && !Shopify.designMode) return;
  try {
    
function redirect(event){
  event.preventDefault();
  location.href= document.getElementById('redirect_button').dataset.url;
}
function isnull(id){
  const input = document.getElementById(id);
  return input.value == null || input.value.trim() == '';
}
function validateEmailString(email) {
  var re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
  return re.test(email);
}
function validateFirstname(event){
  const nameField = document.getElementById('ContactForm-firstname-field');
  const errorField = document.getElementById('ContactForm-firstname-error');
  if(isnull('ContactForm-firstname')){
    nameField.classList.add('error');
    errorField.style.display = 'block';
    event.preventDefault();
  }else{
    errorField.style.display = 'none';
    nameField.classList.remove('error');
  }
}
function validateLastname(event){
  const nameField = document.getElementById('ContactForm-lastname-field');
  const errorField = document.getElementById('ContactForm-lastname-error');
  if(isnull('ContactForm-lastname')){
    nameField.classList.add('error');
    errorField.style.display = 'block';
    event.preventDefault();
  }else{
    errorField.style.display = 'none';
    nameField.classList.remove('error');
  }
}
function validateEmail(event){
  const emailField = document.getElementById('ContactForm-email-field');
  const errorField = document.getElementById('ContactForm-email-error')
  const errorFormatField = document.getElementById('ContactForm-emailformat-error')
  if(isnull('ContactForm-email')){
    emailField.classList.add('error');
    errorField.style.display = 'block';
    event.preventDefault();
  }else{
    errorField.style.display = 'none';
    emailField.classList.remove('error');
    if(!validateEmailString(document.getElementById('ContactForm-email').value)){
      emailField.classList.add('error');
      errorFormatField.style.display = 'block';
      event.preventDefault();
    }else{
      emailField.classList.remove('error');
      errorFormatField.style.display = 'none';
    }
  }
}
  
function validateForm(event){
  validateFirstname(event);
  //validateLastname(event);
  validateEmail(event);
}
document.addEventListener('DOMContentLoaded', function() {
  if(document.getElementById('btnSubmit')) document.getElementById('btnSubmit').addEventListener('mousedown',validateForm);
  if(document.getElementById('ContactForm-email')) document.getElementById('ContactForm-email').addEventListener('blur',validateEmail);
  if(document.getElementById('ContactForm-name')) document.getElementById('ContactForm-name').addEventListener('blur',validateName);
  if(document.getElementById('redirect_button')) document.getElementById('redirect_button').addEventListener('click',redirect);
  
  const signupText = document.getElementById('fomo-signup-signedup-text');
  const queryString = window.location.search;
  if(signupText && queryString.indexOf('form_type=customer') > -1){
    const btnSubmit = document.getElementById('btnSubmit');
    const descriptionText = document.getElementById('fomo-signup-description-text');
    descriptionText.style.display = 'none';
    signupText.style.display = 'block';
    btnSubmit.disabled = true;
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (event.target.matches('.editorial-footer-localization select[name="country_code"]')) {
      event.target.form.requestSubmit();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valfre-wholesale-application"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-wholesale-application]').forEach((application) => {
    const buttons = [...application.querySelectorAll('[data-application-market-button]')];
    const panels = [...application.querySelectorAll('[data-application-market-panel]')];

    const configuredCountryButtons = new WeakSet();
    const pendingCountryButtons = new WeakSet();

    const getOpenRoots = (startingRoot) => {
      const roots = [startingRoot];
      for (const root of roots) {
        root.querySelectorAll('*').forEach((element) => {
          if (element.shadowRoot && !roots.includes(element.shadowRoot)) roots.push(element.shadowRoot);
        });
      }
      return roots;
    };

    const defaultPhoneCountriesToUnitedStates = () => {
      panels.forEach((panel) => {
        getOpenRoots(panel).forEach((root) => {
          root.querySelectorAll('button').forEach((countryButton) => {
            const accessibleName = `${countryButton.getAttribute('aria-label') || ''} ${countryButton.textContent || ''}`;
            if (!/country code/i.test(accessibleName)) return;
            if (configuredCountryButtons.has(countryButton) || pendingCountryButtons.has(countryButton)) return;

            if (/united states|\+1\b/i.test(accessibleName)) {
              configuredCountryButtons.add(countryButton);
              return;
            }

            pendingCountryButtons.add(countryButton);
            countryButton.click();
            let attempts = 0;

            const chooseUnitedStates = () => {
              const unitedStatesOption = getOpenRoots(panel)
                .map((root) => root.querySelector('[id="select-country-US"]'))
                .find(Boolean);

              if (unitedStatesOption) {
                unitedStatesOption.click();
                pendingCountryButtons.delete(countryButton);
                configuredCountryButtons.add(countryButton);
                return;
              }

              attempts += 1;
              if (attempts < 20) {
                window.setTimeout(chooseUnitedStates, 75);
              } else {
                pendingCountryButtons.delete(countryButton);
              }
            };

            window.setTimeout(chooseUnitedStates, 0);
          });
        });
      });
    };

    const runPhoneCountryInitializer = () => {
      [0, 250, 750, 1500, 3000].forEach((delay) => {
        window.setTimeout(defaultPhoneCountriesToUnitedStates, delay);
      });
    };

    buttons.forEach((button) => button.addEventListener('click', () => {
      const market = button.dataset.applicationMarketButton;
      buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      panels.forEach((panel) => { panel.hidden = panel.dataset.applicationMarketPanel !== market; });
      runPhoneCountryInitializer();
    }));

    runPhoneCountryInitializer();

    application.querySelectorAll('[data-policy-open]').forEach((button) => {
      button.addEventListener('click', () => {
        application.querySelector(`[data-policy-dialog="${button.dataset.policyOpen}"]`)?.showModal();
      });
    });
    application.querySelectorAll('[data-policy-close]').forEach((button) => {
      button.addEventListener('click', () => button.closest('dialog')?.close());
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valfre-wholesale-linesheet"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-linesheet-print]').forEach((button) => {
    button.addEventListener('click', () => window.print());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valfre-wholesale-portal"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.vw-portal').forEach((portal) => {
    const marketButtons = [...portal.querySelectorAll('[data-application-market]')];
    const marketPanels = [...portal.querySelectorAll('[data-application-panel]')];
    marketButtons.forEach((button) => button.addEventListener('click', () => {
      marketButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      marketPanels.forEach((panel) => { panel.hidden = panel.dataset.applicationPanel !== button.dataset.applicationMarket; });
    }));
  });

  class ValfreWholesaleOrder {
    constructor(root) {
      this.root = root;
      this.rows = [...root.querySelectorAll('[data-order-row]')];
      this.lines = [...root.querySelectorAll('[data-order-line]')];
      this.search = root.querySelector('[data-order-search]');
      this.searchSubmit = root.querySelector('[data-order-search-submit]');
      this.searchClear = root.querySelector('[data-order-search-clear]');
      this.category = root.querySelector('[data-order-category]');
      this.sort = root.querySelector('[data-order-sort]');
      this.rowContainer = root.querySelector('.vw-order__rows');
      this.selectedToggle = root.querySelector('[data-selected-toggle]');
      this.selectedCount = root.querySelector('[data-selected-count]');
      this.preorderDivider = root.querySelector('[data-preorder-divider]');
      this.categoryDividers = [];
      this.availabilityButtons = [...root.querySelectorAll('[data-availability-filter]')];
      this.availabilityFilter = 'all';
      this.viewHeading = root.querySelector('[data-view-heading]');
      this.outOfStockCount = root.querySelector('[data-out-of-stock-count]');
      this.noResults = root.querySelector('[data-no-results]');
      this.reference = root.querySelector('[data-order-reference]');
      this.note = root.querySelector('[data-order-note]');
      this.feedback = root.querySelector('[data-order-feedback]');
      this.viewOrder = root.querySelector('[data-view-order]');
      this.minimumOrderStatus = root.querySelector('[data-minimum-order-status]');
      this.subtotal = 0;
      this.categorySequence = [
        'planner',
        'calendar',
        'coloring-books',
        'sketchbooks',
        'spiral-notebooks',
        'postcards',
        'water-bottle',
        'tote-bags',
        'makeup-bags',
        'coin-purses',
        'wallet',
        'ceramics',
        'keychain',
        'puzzles',
        'crossbody-phone-case',
        'stamp-sets',
        'pillows',
        'pins',
        'stickers',
        't-shirts',
        'preorders'
      ];
      this.restockDialog = root.querySelector('[data-restock-dialog]');
      this.restockForm = root.querySelector('[data-restock-form]');
      this.restockProduct = root.querySelector('[data-restock-product]');
      this.restockEmail = root.querySelector('[data-restock-email]');
      this.restockVariantId = root.querySelector('[data-restock-variant-id]');
      this.restockSku = root.querySelector('[data-restock-sku]');
      this.restockFeedback = root.querySelector('[data-restock-feedback]');
      this.syncTimers = new WeakMap();
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD'
      });
      if (this.sort) this.sort.value = 'category';
      if (this.category) this.category.value = '';
      if (this.search) this.search.value = '';
      this.initializeReference();
      this.populateCategories();
      if (this.outOfStockCount) {
        this.outOfStockCount.textContent = `(${this.rows.filter((row) => row.dataset.availabilityGroup === 'unavailable').length})`;
      }
      this.bind();
      this.sortRows();
      this.updateSummary();
      this.hydrateFromCart();
    }

    populateCategories() {
      const categories = new Map();
      this.rows.forEach((row) => {
        if (row.dataset.category) categories.set(row.dataset.category, row.dataset.categoryLabel);
      });
      if (this.rows.some((row) => row.dataset.preorderProduct === 'true')) {
        categories.set('preorders', this.root.dataset.preorderCategoryLabel);
      }
      [...categories.entries()].sort((a, b) => {
        return this.categoryRank(a[0]) - this.categoryRank(b[0]) || a[1].localeCompare(b[1]);
      }).forEach(([value, label]) => {
        this.category.add(new Option(label, value));
      });
    }

    categoryRank(category) {
      const rank = this.categorySequence.indexOf(category);
      return rank === -1 ? this.categorySequence.length : rank;
    }

    initializeReference() {
      if (!this.reference) return;
      const portal = this.root.closest('.vw-portal');
      const date = new Date().toISOString().slice(2, 10).replaceAll('-', '');
      const token = globalThis.crypto?.randomUUID
        ? globalThis.crypto.randomUUID().replaceAll('-', '').slice(0, 4).toUpperCase()
        : Math.random().toString(36).slice(2, 6).toUpperCase();
      this.reference.textContent = `${portal.dataset.referencePrefix}-${date}-${token}`;
      fetch(portal.dataset.cartJsonUrl, { headers: { Accept: 'application/json' } })
        .then((response) => response.ok ? response.json() : null)
        .then((cart) => {
          const existingReference = cart?.attributes?.[portal.dataset.referenceAttributeName];
          if (existingReference) this.reference.textContent = existingReference;
        })
        .catch(() => {});
    }

    async hydrateFromCart() {
      const portal = this.root.closest('.vw-portal');
      try {
        const response = await fetch(portal.dataset.cartJsonUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        if (cart.attributes?.[portal.dataset.wholesaleAttributeName] !== portal.dataset.wholesaleAttributeValue) return;
        this.lines.forEach((line) => {
          const input = line.querySelector('[data-order-quantity]');
          const item = cart.items.find((cartItem) => String(cartItem.variant_id) === input.dataset.variantId);
          if (!item) return;
          input.value = item.quantity;
          input.dataset.cartQuantity = String(item.quantity);
          line.dataset.inCart = 'true';
          line.closest('[data-order-row]').dataset.inCart = 'true';
        });
        this.updateSummary();
      } catch (error) {
        this.setFeedback('');
      }
    }

    bind() {
      this.search?.addEventListener('input', () => {
        if (this.searchClear) this.searchClear.hidden = !this.search.value;
      });
      this.search?.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        this.filter();
      });
      this.searchSubmit?.addEventListener('click', () => this.filter());
      this.searchClear?.addEventListener('click', () => {
        this.search.value = '';
        this.searchClear.hidden = true;
        this.filter();
        this.search.focus();
      });
      this.category?.addEventListener('change', () => this.filter());
      this.sort?.addEventListener('change', () => this.sortRows());
      this.selectedToggle?.addEventListener('click', () => {
        const selectedOnly = this.selectedToggle.getAttribute('aria-pressed') !== 'true';
        this.selectedToggle.setAttribute('aria-pressed', String(selectedOnly));
        this.filter();
      });
      this.availabilityButtons.forEach((button) => button.addEventListener('click', () => {
        this.availabilityFilter = button.dataset.availabilityFilter;
        this.availabilityButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        if (this.viewHeading) this.viewHeading.textContent = button.dataset.filterLabel || button.textContent.trim();
        this.filter();
      }));
      this.root.querySelectorAll('[data-restock-open]').forEach((button) => button.addEventListener('click', () => this.openRestock(button)));
      this.root.querySelector('[data-restock-close]')?.addEventListener('click', () => this.restockDialog?.close());
      this.restockForm?.addEventListener('submit', (event) => this.requestRestock(event));
      this.viewOrder?.addEventListener('click', async (event) => {
        const portal = this.root.closest('.vw-portal');
        const minimumOrderCents = Number(portal.dataset.minimumOrderCents) || 30000;
        if (this.subtotal < minimumOrderCents) {
          event.preventDefault();
          this.setFeedback(portal.dataset.minimumOrderMessage);
          this.minimumOrderStatus?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          return;
        }
        if (!this.lines.some((line) => line.dataset.inCart === 'true')) return;
        event.preventDefault();
        try {
          await this.prepareWholesaleCart();
          window.location.assign(this.viewOrder.href);
        } catch (error) {
          const portal = this.root.closest('.vw-portal');
          this.setFeedback(error.message === portal.dataset.existingCartError ? error.message : portal.dataset.requestError);
        }
      });
      this.root.addEventListener('click', (event) => {
        const closeDetails = event.target.closest('[data-details-close]');
        if (closeDetails) {
          const details = closeDetails.closest('details');
          const summary = details.querySelector('summary');
          details.removeAttribute('open');
          summary.focus({ preventScroll: true });
          summary.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        const addLine = event.target.closest('[data-add-line]');
        if (addLine) {
          this.syncLine(addLine.closest('[data-order-line]'));
          return;
        }
        const minus = event.target.closest('[data-quantity-minus]');
        const plus = event.target.closest('[data-quantity-plus]');
        if (!minus && !plus) return;
        const input = event.target.closest('[data-order-line]').querySelector('[data-order-quantity]');
        if (input.disabled) return;
        const step = Number(input.step) || 1;
        const current = Number(input.value) || 0;
        const maximum = Number(input.dataset.maximum) || null;
        const nextValue = Math.max(0, current + (plus ? step : -step));
        input.value = maximum ? Math.min(nextValue, maximum) : nextValue;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
      this.root.addEventListener('input', (event) => {
        if (!event.target.matches('[data-order-quantity]')) return;
        const input = event.target;
        input.value = Math.max(0, Number.parseInt(input.value, 10) || 0);
        this.updateSummary();
        const line = input.closest('[data-order-line]');
        if (line.dataset.inCart === 'true') this.scheduleLineSync(line);
      });
    }

    sortRows() {
      const mode = this.sort?.value || 'category';
      this.rows.sort((left, right) => {
        const availabilityRank = { available: 0, preorder: 1, unavailable: 2 };
        if (mode === 'category') {
          return this.categoryRank(left.dataset.category) - this.categoryRank(right.dataset.category)
            || left.dataset.category.localeCompare(right.dataset.category)
            || availabilityRank[left.dataset.availabilityGroup] - availabilityRank[right.dataset.availabilityGroup]
            || left.dataset.sortTitle.localeCompare(right.dataset.sortTitle);
        }
        const availabilityOrder = availabilityRank[left.dataset.availabilityGroup] - availabilityRank[right.dataset.availabilityGroup];
        if (availabilityOrder) return availabilityOrder;
        if (mode === 'title') return left.dataset.sortTitle.localeCompare(right.dataset.sortTitle);
        if (mode === 'price') {
          return Number(left.dataset.sortPrice) - Number(right.dataset.sortPrice) || left.dataset.sortTitle.localeCompare(right.dataset.sortTitle);
        }
        return Number(left.dataset.sortRank) - Number(right.dataset.sortRank);
      }).forEach((row) => this.rowContainer.append(row));
      this.filter();
    }

    renderCategoryGroups() {
      this.categoryDividers.forEach((divider) => divider.remove());
      this.categoryDividers = [];
      if (this.sort?.value !== 'category') return;
      let activeCategory = '';
      this.rows.forEach((row) => {
        if (row.hidden || row.dataset.category === activeCategory) return;
        activeCategory = row.dataset.category;
        const divider = document.createElement('div');
        divider.className = 'vw-order__category-divider';
        divider.textContent = row.dataset.categoryLabel || 'Other';
        row.before(divider);
        this.categoryDividers.push(divider);
      });
    }

    openRestock(button) {
      if (!this.restockDialog) return;
      this.restockForm?.reset();
      if (this.restockProduct) this.restockProduct.textContent = `${button.dataset.product} · ${button.dataset.sku}`;
      if (this.restockVariantId) this.restockVariantId.value = button.dataset.variantId || '';
      if (this.restockSku) this.restockSku.value = button.dataset.sku || '';
      if (this.restockFeedback) {
        this.restockFeedback.textContent = '';
        this.restockFeedback.hidden = true;
      }
      this.restockDialog.showModal();
      this.restockEmail?.focus();
    }

    async requestRestock(event) {
      event.preventDefault();
      const portal = this.root.closest('.vw-portal');
      const endpoint = portal.dataset.restockSignupUrl;
      if (!endpoint) {
        this.restockFeedback.textContent = portal.dataset.restockConfigMessage;
        this.restockFeedback.hidden = false;
        return;
      }
      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            email: this.restockEmail.value.trim(),
            variantId: this.restockVariantId.value,
            sku: this.restockSku.value
          })
        });
        if (!response.ok) throw new Error('Restock signup failed');
        this.restockFeedback.textContent = portal.dataset.restockSuccessMessage;
      } catch (error) {
        this.restockFeedback.textContent = portal.dataset.restockErrorMessage;
      }
      this.restockFeedback.hidden = false;
    }

    scheduleLineSync(line) {
      window.clearTimeout(this.syncTimers.get(line));
      const button = line.querySelector('[data-add-line]');
      button.textContent = button.dataset.updatingLabel;
      button.disabled = true;
      this.syncTimers.set(line, window.setTimeout(() => this.syncLine(line), 500));
    }

    updateLineButton(line) {
      const input = line.querySelector('[data-order-quantity]');
      const button = line.querySelector('[data-add-line]');
      if (!button || input.disabled) return;
      const quantity = Number(input.value) || 0;
      const cartQuantity = Number(input.dataset.cartQuantity) || 0;
      const invalid = input.hasAttribute('aria-invalid');
      button.dataset.added = String(cartQuantity > 0 && quantity === cartQuantity);
      if (quantity === cartQuantity && cartQuantity > 0) {
        button.textContent = button.dataset.addedLabel;
        button.disabled = true;
      } else if (cartQuantity > 0) {
        button.textContent = button.dataset.updateLabel;
        button.disabled = false;
      } else {
        button.textContent = button.dataset.idleLabel;
        button.disabled = quantity === 0 || invalid;
      }
      if (invalid) button.disabled = true;
    }

    async prepareWholesaleCart() {
      const portal = this.root.closest('.vw-portal');
      const cartResponse = await fetch(portal.dataset.cartJsonUrl, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Cart request failed');
      const cart = await cartResponse.json();
      const wholesaleAttribute = cart.attributes?.[portal.dataset.wholesaleAttributeName];
      if (cart.item_count > 0 && wholesaleAttribute !== portal.dataset.wholesaleAttributeValue) {
        throw new Error(portal.dataset.existingCartError);
      }
      const attributes = {
        [portal.dataset.wholesaleAttributeName]: portal.dataset.wholesaleAttributeValue,
        [portal.dataset.shippingAttributeName]: portal.dataset.shippingAttributeValue
      };
      const reference = cart.attributes?.[portal.dataset.referenceAttributeName] || this.reference?.textContent.trim();
      if (reference) attributes[portal.dataset.referenceAttributeName] = reference;
      const response = await fetch(portal.dataset.cartUpdateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes, note: this.note?.value.trim() || cart.note || '' })
      });
      if (!response.ok) throw new Error('Cart attribute request failed');
      return cart;
    }

    async syncLine(line) {
      const portal = this.root.closest('.vw-portal');
      const input = line.querySelector('[data-order-quantity]');
      const button = line.querySelector('[data-add-line]');
      const quantity = Number(input.value) || 0;
      const cartQuantity = Number(input.dataset.cartQuantity) || 0;
      if (!this.validateQuantity(input) || quantity === cartQuantity) {
        this.updateLineButton(line);
        return;
      }
      window.clearTimeout(this.syncTimers.get(line));
      button.textContent = button.dataset.updatingLabel;
      button.disabled = true;
      this.setFeedback('');
      try {
        await this.prepareWholesaleCart();
        let response;
        if (cartQuantity === 0 && quantity > 0) {
          const item = { id: input.dataset.variantId, quantity };
          if (input.dataset.preorder === 'true' && input.dataset.preorderMessage) {
            item.properties = { [input.dataset.preorderPropertyName]: input.dataset.preorderMessage };
          }
          response = await fetch(portal.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [item] })
          });
        } else {
          response = await fetch(portal.dataset.cartUpdateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: { [input.dataset.variantId]: quantity } })
          });
        }
        if (!response.ok) throw new Error('Cart line request failed');
        input.dataset.cartQuantity = String(quantity);
        line.dataset.inCart = String(quantity > 0);
        const productRow = line.closest('[data-order-row]');
        productRow.dataset.inCart = String([...productRow.querySelectorAll('[data-order-line]')].some((item) => item.dataset.inCart === 'true'));
      } catch (error) {
        this.setFeedback(error.message === portal.dataset.existingCartError ? error.message : portal.dataset.requestError);
      }
      this.updateSummary();
    }

    filter() {
      const query = this.search.value.trim().toLowerCase();
      const category = this.category.value;
      const selectedOnly = this.selectedToggle?.getAttribute('aria-pressed') === 'true';
      let visible = 0;
      let visiblePreorders = 0;
      this.rows.forEach((row) => {
        const matchesQuery = !query || row.dataset.search.includes(query);
        const isPreorderProduct = row.dataset.preorderProduct === 'true';
        const matchesCategory = !category || (category === 'preorders' ? isPreorderProduct : row.dataset.category === category);
        const matchesAvailability = this.availabilityFilter === 'all' || row.dataset.availabilityGroup === this.availabilityFilter;
        const matchesSelected = !selectedOnly || [...row.querySelectorAll('[data-order-quantity]')].some((input) => (Number(input.value) || 0) > 0);
        row.hidden = !(matchesQuery && matchesCategory && matchesAvailability && matchesSelected);
        if (!row.hidden) {
          visible += 1;
          if (isPreorderProduct) visiblePreorders += 1;
        }
      });
      this.noResults.hidden = visible > 0;
      if (this.preorderDivider) this.preorderDivider.hidden = this.sort?.value === 'category' || visiblePreorders === 0 || this.availabilityFilter !== 'all';
      this.renderCategoryGroups();
    }

    updateSummary() {
      let skus = 0;
      let units = 0;
      let preorderUnits = 0;
      let subtotal = 0;
      this.lines.forEach((line) => {
        const input = line.querySelector('[data-order-quantity]');
        const quantity = Number(input.value) || 0;
        this.validateQuantity(input);
        const lineTotal = quantity * Number(input.dataset.price || 0);
        line.querySelector('[data-line-total]').textContent = this.money.format(lineTotal / 100);
        if (quantity > 0) skus += 1;
        units += quantity;
        if (input.dataset.preorder === 'true') preorderUnits += quantity;
        subtotal += lineTotal;
        this.updateLineButton(line);
      });
      this.root.querySelector('[data-summary-skus]').textContent = skus;
      if (this.selectedCount) this.selectedCount.textContent = skus;
      this.root.querySelector('[data-summary-units]').textContent = units;
      this.root.querySelector('[data-summary-preorder-units]').textContent = preorderUnits;
      this.root.querySelector('[data-summary-total]').textContent = this.money.format(subtotal / 100);
      this.subtotal = subtotal;
      const portal = this.root.closest('.vw-portal');
      const minimumOrderCents = Number(portal.dataset.minimumOrderCents) || 30000;
      const remaining = Math.max(0, minimumOrderCents - subtotal);
      if (this.minimumOrderStatus) {
        this.minimumOrderStatus.dataset.ready = String(subtotal >= minimumOrderCents);
        this.minimumOrderStatus.textContent = subtotal >= minimumOrderCents
          ? 'The $300 wholesale order minimum has been met.'
          : `${this.money.format(remaining / 100)} more is required to reach the $300 wholesale order minimum.`;
      }
      if (this.viewOrder) this.viewOrder.setAttribute('aria-disabled', String(subtotal < minimumOrderCents));
      if (this.selectedToggle?.getAttribute('aria-pressed') === 'true') this.filter();
    }

    validateQuantity(input) {
      const quantity = Number(input.value) || 0;
      const minimum = Number(input.dataset.minimum) || 1;
      const increment = Number(input.step) || 1;
      const maximum = Number(input.dataset.maximum) || null;
      const error = input.closest('[data-order-line]').querySelector('[data-quantity-error]');
      let message = '';
      if (quantity > 0 && quantity < minimum) message = error.dataset.minimumError;
      else if (quantity > 0 && (quantity - minimum) % increment !== 0) message = error.dataset.incrementError;
      else if (maximum && quantity > maximum) message = error.dataset.maximumError;
      if (message) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
      error.textContent = message;
      error.hidden = !message;
      return !message;
    }

    setFeedback(message) {
      if (!this.feedback) return;
      this.feedback.textContent = message;
      this.feedback.hidden = !message;
    }
  }

  document.querySelectorAll('[data-wholesale-order]').forEach((root) => new ValfreWholesaleOrder(root));

  } catch(e) { console.error(e); }
})();
})();
